Theme.ComponentCollections.MenuDropdowns = (function () {
  const collection = new Theme.ComponentCollection("component-menu-dropdown");

  hide_on_click();
  hide_on_scroll();
  hide_on_resize();

  function hide_on_click() {
    document.addEventListener("click", (event) => {
      const clickedMegamenu = event.target.closest(
        "component-menu-dropdown, .navigation-megamenu-link"
      );

      if (!clickedMegamenu) {
        hide();
      }
    }, true);
  }

  function hide_on_scroll() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          hide();
        }
      });
    }, { threshold: 0.1 });

    collection.elements.forEach(element => {
      observer.observe(element);
    });
  }

  function hide_on_resize() {
    const mediaQuery = window.matchMedia("(max-width: 1023px)");

    mediaQuery.addEventListener("change", (event) => {
      if (event.matches) {
        hide();
      }
    });
  }

  function hide(options) {
    const except = options && options.except;

    collection.elements.forEach(element => {
      if (element !== except) {
        element.hide();
      }
    });
  }

  return {
    hide
  }
})();

class ComponentMenuDropdown extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      "dropdown": ".menu-dropdown"
    });

    this.collection = Theme.ComponentCollections.MenuDropdowns;
  }

  connectedCallback() {
    super.connectedCallback();
    this.onMegamenuClick = this.onMegamenuClick.bind(this);
    document.addEventListener("megamenu:click", this.onMegamenuClick);

    this.addEventListener("mouseenter", () => {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    });

    this.addEventListener("mouseleave", () => {
      this.hideOnLeave();
    });

    this.bindTriggerHover();
  }

  bindTriggerHover() {
    this.hoverQuery = window.matchMedia("(hover: hover) and (min-width: 1024px)");
    this.trigger = document.querySelector(".navigation-megamenu-link");

    if (!this.trigger) {
      return;
    }

    this.onTriggerEnter = () => {
      if (!this.hoverQuery.matches) {
        return;
      }

      if (!this.classList.contains("active--true")) {
        this.hoverOpenedAt = performance.now();
      }

      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    };

    this.onTriggerLeave = () => {
      if (!this.hoverQuery.matches) {
        return;
      }

      this.hideOnLeave();
    };

    this.trigger.addEventListener("mouseenter", this.onTriggerEnter);
    this.trigger.addEventListener("mouseleave", this.onTriggerLeave);
  }

  hideOnLeave() {
    window.clearTimeout(this.leaveTimer);

    this.leaveTimer = window.setTimeout(() => {
      if (this.matches(":hover") || this.trigger?.matches(":hover")) {
        return;
      }

      this.hide();
    }, 150);
  }

  disconnectedCallback() {

    super.disconnectedCallback();
    document.removeEventListener("megamenu:click", this.onMegamenuClick);
    window.clearTimeout(this.leaveTimer);

    if (this.trigger) {
      this.trigger.removeEventListener("mouseenter", this.onTriggerEnter);
      this.trigger.removeEventListener("mouseleave", this.onTriggerLeave);
    }
  }

  onMegamenuClick() {
    const clickFollowsHoverOpen = this.hoverOpenedAt
      && performance.now() - this.hoverOpenedAt < 500;

    if (clickFollowsHoverOpen) {
      this.hoverOpenedAt = null;
      return;
    }

    if (this.classList.contains("active--true")) {
      this.hide();
    } else {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    }
  }

  toggle() {
    if (this.classList.contains("active--true")) {
      this.hide();
    } else {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    }
  }

hide() {
  if (!this.classList.contains("active--true")) {
    return;
  }

  this.classList.remove("active--true");

  const nav = document.querySelector(".navigation");
  if (nav) nav.classList.remove("navigation--dropdown-active");

  this.elements.dropdown.addEventListener("transitionend", () => {
  }, { once: true });
}

  show() {
    return new Promise(resolve => {
      requestAnimationFrame(() => {
        this.classList.add("active--true");

        const nav = document.querySelector(".navigation");
        if (nav) nav.classList.add("navigation--dropdown-active");

        setTimeout(() => {
          resolve();
        }, 150);
      });
    });
  }
}

customElements.define("component-menu-dropdown", ComponentMenuDropdown);
